import { Mail, Phone, MapPin, ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useTheme } from '../context/ThemeContext';

const Footer = () => {
  const { theme } = useTheme();

  const footerClasses = theme === 'dark' ? 'bg-gray-900 text-gray-300' : 'bg-gray-100 text-gray-700';
  const headingClasses = theme === 'dark' ? 'text-white' : 'text-gray-900';
  const textClasses = theme === 'dark' ? 'text-gray-400' : 'text-gray-600';
  const hoverClasses = theme === 'dark' ? 'hover:text-emerald-600' : 'hover:text-emerald-600';
  const iconClasses = theme === 'dark' ? 'text-emerald-600' : 'text-emerald-600';
  const borderClasses = theme === 'dark' ? 'border-gray-800' : 'border-gray-200';

  return (
    <footer className={`${footerClasses} transition-colors duration-300`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 sm:py-12 lg:py-16">
        {/* Desktop Footer (Visible on md and larger screens) */}
        <div className="hidden md:block">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 sm:gap-12">
            {/* About Section */}
            <div className="text-center sm:text-left">
              <h3 className={`text-xl sm:text-2xl font-bold ${headingClasses} mb-4 sm:mb-6 font-display`}>
                VG Foods
              </h3>
              <p className={`mb-4 sm:mb-6 text-sm sm:text-base ${textClasses} font-sans`}>
                Bringing you the finest selection of vegetarian, vegan, and non-vegetarian dishes, 
                prepared with love and served with care.
              </p>
             
            </div>

            {/* Quick Links */}
            <div className="text-center sm:text-left">
              <h4 className={`text-lg sm:text-xl font-semibold ${headingClasses} mb-4 sm:mb-6 font-display`}>
                Quick Links
              </h4>
              <div className="grid grid-cols-2 gap-3 sm:gap-4">
                <ul className="space-y-3 sm:space-y-4">
                  <li>
                    <Link to="/" className={`flex items-center justify-center sm:justify-start ${hoverClasses} transition-colors text-sm sm:text-base font-sans`}>
                      <ArrowRight className="w-4 h-4 mr-2" /> Home
                    </Link>
                  </li>
                  <li>
                    <Link to="/menu" className={`flex items-center justify-center sm:justify-start ${hoverClasses} transition-colors text-sm sm:text-base font-sans`}>
                      <ArrowRight className="w-4 h-4 mr-2" /> Menu
                    </Link>
                  </li>
                  <li>
                    <Link to="/about" className={`flex items-center justify-center sm:justify-start ${hoverClasses} transition-colors text-sm sm:text-base font-sans`}>
                      <ArrowRight className="w-4 h-4 mr-2" /> About Us
                    </Link>
                  </li>
                  <li>
                    <Link to="/contact" className={`flex items-center justify-center sm:justify-start ${hoverClasses} transition-colors text-sm sm:text-base font-sans`}>
                      <ArrowRight className="w-4 h-4 mr-2" /> Contact
                    </Link>
                  </li>
                </ul>
                <ul className="space-y-3 sm:space-y-4">
                  <li>
                    <Link to="/dine-in" className={`flex items-center justify-center sm:justify-start ${hoverClasses} transition-colors text-sm sm:text-base font-sans`}>
                      <ArrowRight className="w-4 h-4 mr-2" /> Dine In
                    </Link>
                  </li>
                  <li>
                    <Link to="/takeaway" className={`flex items-center justify-center sm:justify-start ${hoverClasses} transition-colors text-sm sm:text-base font-sans`}>
                      <ArrowRight className="w-4 h-4 mr-2" /> Takeaway
                    </Link>
                  </li>
                  <li>
                    <Link to="/party-order" className={`flex items-center justify-center sm:justify-start ${hoverClasses} transition-colors text-sm sm:text-base font-sans`}>
                      <ArrowRight className="w-4 h-4 mr-2" /> Party Order
                    </Link>
                  </li>
                  <li>
                    <a
                      href="https://wa.me/447521262119"
                      target="_blank"
                      rel="noopener noreferrer"
                      className={`flex items-center justify-center sm:justify-start ${hoverClasses} transition-colors text-sm sm:text-base font-sans whitespace-nowrap`}
                    >
                      <ArrowRight className="w-4 h-4 mr-2" /> WhatsApp Order
                    </a>
                  </li>
                </ul>
              </div>
            </div>

            {/* Contact Info */}
            <div className="text-center sm:text-left">
              <h4 className={`text-lg sm:text-xl font-semibold ${headingClasses} mb-4 sm:mb-6 font-display`}>
                Contact Info
              </h4>
              <ul className="space-y-3 sm:space-y-4 text-sm sm:text-base font-sans">
                <li className="flex flex-col sm:flex-row items-center">
                  <MapPin className={`w-8 h-5 mb-2 sm:mb-0 sm:mr-3 ${iconClasses}`} />
                  <span>855 Bristol Rd South, Northfield, Birmingham B31 2PA</span>
                </li>
                <li className="flex justify-center sm:justify-start items-center">
                  <Phone className={`w-5 h-5 mr-3 ${iconClasses}`} />
                  <span>07521 262119</span>
                </li>
                <li className="flex justify-center sm:justify-start items-center">
                  <Mail className={`w-5 h-5 mr-3 ${iconClasses}`} />
                  <span>vgfoodsuk@gmail.com</span>
                </li>
              </ul>
            </div>

            {/* Opening Hours */}
            <div className="text-center sm:text-left">
              <h4 className={`text-lg sm:text-xl font-semibold ${headingClasses} mb-4 sm:mb-6 font-display`}>
                Opening Hours
              </h4>
              <ul className="space-y-3 sm:space-y-4 text-sm sm:text-base font-sans">
                <li className="flex flex-col sm:flex-row justify-between">
                  <span>Monday - Friday</span>
                  <span className="mt-1 sm:mt-0">10:00 AM - 5:00 PM</span>
                </li>
                <li className="flex flex-col sm:flex-row justify-between">
                  <span>Saturday</span>
                  <span className="mt-1 sm:mt-0">10:00 AM - 5:00 PM</span>
                </li>
                <li className="flex flex-col sm:flex-row justify-between">
                  <span>Sunday</span>
                  <span className="mt-1 sm:mt-0">10:00 AM - 5:00 PM</span>
                </li>
              </ul>
            </div>
          </div>

          {/* Bottom Bar (Desktop) */}
          <div className={`border-t ${borderClasses} mt-8 sm:mt-12 pt-6 sm:pt-8 text-center`}>
            <div className="flex flex-col items-center">
              <p className={`text-xs sm:text-sm ${textClasses} mb-2 sm:mb-0 font-sans`}>
                © {new Date().getFullYear()} VG Foods. All rights reserved.
              </p>
              <p className={`text-xs sm:text-sm ${textClasses} mb-4 sm:mb-4 font-sans`}>
                <a 
                  href="https://www.linkedin.com/in/krisanth-m" 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  className={`${hoverClasses} transition-colors`}
                >
                  Krisanth M
                </a>
                {' & '}
                <a 
                  href="https://www.linkedin.com/in/darshanuthayakumar" 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  className={`${hoverClasses} transition-colors`}
                >
                  Darshan U
                </a>
              </p>
              <div className="flex flex-col sm:flex-row space-y-3 sm:space-y-0 sm:space-x-6">
                <Link to="/privacy-policy" className={`text-xs sm:text-sm ${textClasses} ${hoverClasses} transition-colors font-sans`}>
                  Privacy Policy
                </Link>
                <Link to="/terms-of-service" className={`text-xs sm:text-sm ${textClasses} ${hoverClasses} transition-colors font-sans`}>
                  Terms of Service
                </Link>
                <Link to="/cookie-policy" className={`text-xs sm:text-sm ${textClasses} ${hoverClasses} transition-colors font-sans`}>
                  Cookie Policy
                </Link>
              </div>
            </div>
          </div>
        </div>

        {/* Mobile Footer (Visible on screens smaller than md) */}
        <div className="md:hidden">
          <div className="space-y-6">
            {/* About Section */}
            <div>
              <h3 className={`text-lg font-bold ${headingClasses} mb-3 uppercase tracking-wide font-display`}>
                About VG Foods
              </h3>
              <p className={`text-sm ${textClasses} mb-4 font-sans`}>
                Bringing you the finest selection of vegetarian, vegan, and non-vegetarian dishes, 
                prepared with love and served with care.
              </p>
            </div>

            {/* Quick Links */}
            <div>
              <h4 className={`text-lg font-bold ${headingClasses} mb-3 uppercase tracking-wide font-display`}>
                Quick Links
              </h4>
              <div className="flex flex-wrap gap-4 text-sm font-sans">
                <Link to="/" className={`${textClasses} ${hoverClasses}`}>Home</Link>
                <Link to="/menu" className={`${textClasses} ${hoverClasses}`}>Menu</Link>
                <Link to="/about" className={`${textClasses} ${hoverClasses}`}>About Us</Link>
                <Link to="/contact" className={`${textClasses} ${hoverClasses}`}>Contact</Link>
                <Link to="/dine-in" className={`${textClasses} ${hoverClasses}`}>Dine In</Link>
                <Link to="/takeaway" className={`${textClasses} ${hoverClasses}`}>Takeaway</Link>
                <Link to="/party-order" className={`${textClasses} ${hoverClasses}`}>Party Order</Link>
                <a
                  href="https://wa.me/447521262119"
                  target="_blank"
                  rel="noopener noreferrer"
                  className={`${textClasses} ${hoverClasses}`}
                >
                  WhatsApp Order
                </a>
              </div>
            </div>

            {/* Contact Info */}
            <div>
              <h4 className={`text-lg font-bold ${headingClasses} mb-3 uppercase tracking-wide font-display`}>
                Contact Info
              </h4>
              <ul className="space-y-2 text-sm font-sans">
                <li className="flex items-center">
                  <MapPin className={`w-4 h-4 mr-2 ${iconClasses}`} />
                  <span className={`${textClasses}`}>855 Bristol Rd South, Northfield, Birmingham B31 2PA</span>
                </li>
                <li className="flex items-center">
                  <Phone className={`w-4 h-4 mr-2 ${iconClasses}`} />
                  <span className={`${textClasses}`}>07521 262119</span>
                </li>
                <li className="flex items-center">
                  <Mail className={`w-4 h-4 mr-2 ${iconClasses}`} />
                  <span className={`${textClasses}`}>vgfoodsuk@gmail.com</span>
                </li>
              </ul>
            </div>

            {/* Opening Hours */}
            <div>
              <h4 className={`text-lg font-bold ${headingClasses} mb-3 uppercase tracking-wide font-display`}>
                Opening Hours
              </h4>
              <ul className="space-y-2 text-sm font-sans">
                <li className="flex justify-between">
                  <span className={`${textClasses}`}>Monday - Friday</span>
                  <span className={`${textClasses}`}>10:00 AM - 5:00 PM</span>
                </li>
                <li className="flex justify-between">
                  <span className={`${textClasses}`}>Saturday</span>
                  <span className={`${textClasses}`}>10:00 AM - 5:00 PM</span>
                </li>
                <li className="flex justify-between">
                  <span className={`${textClasses}`}>Sunday</span>
                  <span className={`${textClasses}`}>10:00 AM - 5:00 PM</span>
                </li>
              </ul>
            </div>

            {/* Learn More */}
            <div>
              <h4 className={`text-lg font-bold ${headingClasses} mb-3 uppercase tracking-wide font-display`}>
                Learn More
              </h4>
              <div className="flex flex-wrap gap-4 text-sm font-sans">
                <Link to="/privacy-policy" className={`${textClasses} ${hoverClasses}`}>Privacy Policy</Link>
                <Link to="/terms-of-service" className={`${textClasses} ${hoverClasses}`}>Terms of Service</Link>
                <Link to="/cookie-policy" className={`${textClasses} ${hoverClasses}`}>Cookie Policy</Link>
              </div>
            </div>
          </div>

          {/* Bottom Bar (Mobile) */}
          <div className={`border-t ${borderClasses} mt-6 pt-6 text-center`}>
            <p className={`text-xs ${textClasses} mb-2 font-sans`}>
              © {new Date().getFullYear()} VG Foods. All rights reserved.
            </p>
            <p className={`text-xs ${textClasses} mb-4 font-sans`}>
              <a
                href="https://www.linkedin.com/in/krisanth-m"
                target="_blank"
                rel="noopener noreferrer"
                className={`${hoverClasses}`}
              >
                Krisanth M
              </a>
              {' & '}
              <a
                href="https://www.linkedin.com/in/darshanuthayakumar"
                target="_blank"
                rel="noopener noreferrer"
                className={`${hoverClasses}`}
              >
                Darshan U
              </a>
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;